const SENTINEL_ORIGIN = 'http://redirect.invalid'

// Browsers drop tab/CR/LF (and trim other C0 controls) from a URL before resolving it, so
// '/\t/evil.com' navigates like '//evil.com'. Anything carrying them is rejected outright.
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/

/**
 * Reduces an untrusted post-auth redirect target to a same-origin path, or '/'.
 *
 * Only a path starting with a single '/' survives: protocol-relative ('//evil.com'), backslash
 * ('/\evil.com', which browsers read as '//'), absolute URLs and `javascript:` all fall back to
 * '/'. The final URL resolution is the backstop for any spelling the prefix checks miss.
 */
export function sanitizeRedirectPath(path: string): string {
  if (!path.startsWith('/')) return '/'
  if (path.startsWith('//') || path.startsWith('/\\')) return '/'
  if (CONTROL_CHARS.test(path)) return '/'
  try {
    if (new URL(path, SENTINEL_ORIGIN).origin !== SENTINEL_ORIGIN) return '/'
  } catch {
    return '/'
  }
  return path
}
